class TaskExecutor {
    constructor(concurrency) {
        this._concurrency = concurrency;
        this._running = 0;
        this._taskPromises = {};
    }

    async addTask(id, task) {
        //console.info(`Task adding [${id}]`);
        if (this._running >= this._concurrency) {
            // wait for any task to finish
            await Promise.any(Object.values(this._taskPromises));
        }

        // add task to run
        this._running++;
        let taskPromise = new Promise(async (resolve) => {
            await task;
            //console.info(`Task done [${id}]`);
            delete this._taskPromises[id];
            this._running--;
            resolve();
        });
        this._taskPromises[id] = taskPromise;
        //console.info(`Task added [${id}]`);
    }

    async awaitAll() {
        await Promise.all(Object.values(this._taskPromises));
        //console.info(`Task done ALL`);
    }
}

export default TaskExecutor;